import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organizations/$organizationId/teacher/classes_/$classId/updates")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
